<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, provide, watch, onBeforeUnmount } from "vue";
import { useMagicKeys, usePointer } from "@vueuse/core";
import { Primitive } from "@maas/vue-primitive";
import { createDefu } from "defu";
import { useCommandState } from "../composables/private/useCommandState";
import { useMagicCommand } from "../composables/useMagicCommand";
import { defaultOptions } from "../utils/defaultOptions";
import { MagicCommandInstanceId, MagicCommandProviderOptions } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCommandProvider",
  props: {
    id: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    options: { type: Object, required: false, default: () => ({}) }
  },
  setup(__props) {
    const elRef = ref(void 0);
    const customDefu = createDefu((obj, key, value) => {
      if (key === "open" || key === "close" || key === "next" || key === "prev") {
        obj[key] = value;
        return true;
      }
    });
    const mappedOptions = customDefu(__props.options, defaultOptions);
    const { initializeState, deleteState } = useCommandState(__props.id);
    const state = initializeState(mappedOptions);
    const lastX = ref(0);
    const lastY = ref(0);
    const { x, y } = usePointer();
    watch(
      () => state?.input.type,
      (value) => {
        if (value === "keyboard") {
          lastX.value = x.value;
          lastY.value = y.value;
        }
      }
    );
    watch([x, y], ([x2, y2]) => {
      if (x2 !== lastX.value || y2 !== lastY.value) {
        if (state) {
          state.input.type = "pointer";
        }
      }
    });
    const keys = useMagicKeys();
    const commandApi = useMagicCommand(__props.id);
    const { open, close } = commandApi;
    if (mappedOptions.keyListener?.open) {
      for (const key of mappedOptions.keyListener.open) {
        watch(keys[key], (value) => {
          if (value) {
            open();
          }
        });
      }
    }
    if (mappedOptions.keyListener?.close) {
      for (const key of mappedOptions.keyListener.close) {
        watch(keys[key], (value) => {
          if (value) {
            close();
          }
        });
      }
    }
    onBeforeUnmount(() => {
      deleteState();
    });
    provide(MagicCommandInstanceId, __props.id);
    provide(MagicCommandProviderOptions, mappedOptions);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        ref_key: "elRef",
        ref: elRef,
        "as-child": _ctx.asChild,
        class: "magic-command-provider"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["as-child"]);
    };
  }
});
</script>

<style>
.magic-command-provider {
  outline: none;
  user-select: none;
}
</style>
